module.exports = __webpack_public_path__ + "static/client11-6452fd89c447c9b88f54ce26c038a919.png";